import { groq } from 'next-sanity'

export const PriceBoxesQuery = groq`
_type == "priceBox" => {
  ...,
  prices[] {
  _key,
  title,
  subtitle,
  Price,
  description,
  bullets,
  pdfFile {
      asset->{
        ...,
      }
    }
}
}



`
